<template>
    <b-modal :active="active" @close="close">
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{ $t('emergency_modal_title') }}</p>
            </header>
            <section class="modal-card-body">
                <div class="content">
                    <div class="columns is-multiline">
                        <div class="column is-12">
                            <div class="field">
                                <label>{{ $t('office_name_label') }}</label>
                                <p class="is-size-7"><strong>{{ availability.officeName }}</strong></p>
                            </div>
                        </div>
                        <div class="column is-6">
                            <div class="field">
                                <label>{{ $t('date_label') }}</label>
                                <p class="is-size-7"><strong>{{ availability.date | momentFormat('YYYY-MM-DD', $t('date_selector_format')) }}</strong></p>
                            </div>
                        </div>
                        <div class="column is-6">
                            <div class="field">
                                <label>{{ $t('time_label') }}</label>
                                <p class="is-size-7"><strong>{{ availability.start }} - {{ availability.end }}</strong></p>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <h5 class="title is-5">{{ $t('patient_symptoms_title') }}</h5>

                    <div class="columns is-multiline">
                        <div class="column is-6" v-for="symptom in emergency.symptoms">
                            <div class="field">
                                <label v-text="symptom.question"></label>
                                <p class="is-size-7"><strong v-text="symptom.answer"></strong></p>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <h5 class="title is-5">{{ $t('patient_information_title') }}</h5>

                    <div class="columns is-multiline">
                        <div class="column is-4">
                            <div class="field">
                                <label>{{ $t('patient_first_name_label') }}</label>
                                <p class="is-size-7"><strong>{{ emergency.patientFirstName ? hashPatientInfo(emergency.patientFirstName) : 'N/A' }}</strong></p>
                            </div>
                        </div>
                        <div class="column is-4">
                            <div class="field">
                                <label>{{ $t('patient_last_name_label') }}</label>
                                <p class="is-size-7"><strong>{{ emergency.patientLastName ? hashPatientInfo(emergency.patientLastName) : 'N/A' }}</strong></p>
                            </div>
                        </div>
                        <div class="column is-4">
                            <div class="field">
                                <label>{{ $t('patient_age_label') }}</label>
                                <p class="is-size-7"><strong>{{ emergency.patientAge ? emergency.patientAge : 'N/A' }}</strong></p>
                            </div>
                        </div>
                    </div>
                    <div class="columns is-multiline">
                        <div class="column is-4">
                            <div class="field">
                                <label>{{ $t('patient_email_label') }}</label>
                                <p class="is-size-7"><strong>{{ emergency.patientEmail ? hashPatientInfo(emergency.patientEmail) : 'N/A' }}</strong></p>
                            </div>
                        </div>
                        <div class="column is-4">
                            <div class="field">
                                <label>{{ $t('patient_phone_label') }}</label>
                                <p class="is-size-7"><strong>{{ emergency.patientPhone ? hashPatientInfo(emergency.patientPhone) : 'N/A' }}</strong></p>
                            </div>
                        </div>
                    </div>
                    <div class="columns is-multiline">
                        <div class="column is-4">
                            <div class="field">
                                <label>{{ $t('patient_locality_label') }}</label>
                                <p class="is-size-7"><strong>{{ emergency.locality ? emergency.locality : 'N/A' }}</strong></p>
                            </div>
                        </div>
                        <div class="column is-4">
                            <div class="field">
                                <label>{{ $t('patient_zip_code_label') }}</label>
                                <p class="is-size-7"><strong>{{ emergency.zipCode ? emergency.zipCode : 'N/A' }}</strong></p>
                            </div>
                        </div>
                    </div>

                    <hr>

                    <h5 class="title is-5 mb-0">{{ $t('pictures_title') }}</h5>

                    <div class="message is-warning my-3" v-if="emergency.pictures.length == 0">
                        <div class="message-body">
                            {{ $t('no_pictures_placeholder') }}
                        </div>
                    </div>

                    <figure class="image thumbnail is-128x128 is-inline-block" v-for="picture in emergency.pictures" @click.prevent="showPicture(picture)">
                        <img :src="picture" :alt="$t('picture_alt')" >
                    </figure>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click.prevent="close">{{ $t('close_button_label') }}</button>
            </footer>
        </div>
    </b-modal>
</template>
<script>
    import helpers from '@/mixins/helpers'

    export default {
        props: ['active', 'availability', 'emergency'],

        mixins: [helpers],

        methods: {
            close() {
                this.$emit('close')
                document.documentElement.classList.toggle('is-clipped', false)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/EmergencyModal.vue